import { Fragment, useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import Chart from "react-apexcharts";
import { ChevronLeft, ChevronRight } from "react-feather";
import CollapseableCard from "../../../CommonElements/Collapse/CollapseableCard";

const TotalChart = (props) => {

  const { updatedanggaranbuklist } = props;

  let isMounted = true;
  useEffect(() => {
    if (updatedanggaranbuklist && updatedanggaranbuklist.length > 0) {
      getCompareData(updatedanggaranbuklist);
    }
  }, [updatedanggaranbuklist]);

  const colors = [
    "#33FF57",
    "#3357FF",
    "#FF33A8",
    "#FFBD33",
    "#33FFF0",
    "#AF33FF",
    "#FF8F33",
    "#8FFF33",
    "#3388FF",
    "#FF33EC",
    "#FF5733",
    "#5733FF",
    "#A8FF33",
    "#33FFD7",
    "#FF33AF",
    "#FFBD33",
    "#33FF8F",
    "#5733FF",
    "#FF3388",
    "#8FFF33",
    "#33FF57",
    "#3357FF",
  ];

  const [totalOptions, setTotalOptions] = useState({
    series: [],
    labels: [],
    colors,
  });
  const [realisasiOptions, setRealisasiOptions] = useState({
    series: [],
    labels: [],
    colors,
  });
  const [sisaOptions, setSisaOptions] = useState({
    series: [],
    labels: [],
    colors,
  });
  const [currentSlide, setCurrentSlide] = useState(0);

  const getCompareData = (data) => {
    const dataFasilkom = data.find((item) => item.id_unit_kerja === "Fasilkom");

    let totalFasilkom = parseInt(dataFasilkom?.total_anggaran || 0);
    let terpakaiFasilkom = parseInt(dataFasilkom?.total_terpakai || 0);
    let sisaFasilkom = parseInt(dataFasilkom?.total_sisa || 0);

    let filterData = data.filter(
      (item) => item.id_unit_kerja !== "Fasilkom" && item.total_anggaran !== "0"
    );

    const dataLabels = filterData.map((item) => item.id_unit_kerja);
    const totalAnggaran = filterData.map((item) =>
      parseFloat((parseInt(item.total_anggaran) / totalFasilkom).toFixed(5))
    );
    const totalTerpakai = filterData.map((item) =>
      parseFloat((parseInt(item.total_terpakai) / terpakaiFasilkom).toFixed(5))
    );
    const totalSisa = filterData.map((item) =>
      parseFloat((parseInt(item.total_sisa) / sisaFasilkom).toFixed(5))
    );

    const normalize = (data) => {
      const sum = data.reduce((a, b) => a + b, 0);
      return data.map((value) => parseFloat((value / sum).toFixed(5)));
    };

    setTotalOptions((prevState) => ({
      ...prevState,
      series: normalize(totalAnggaran),
      labels: dataLabels,
    }));
    setRealisasiOptions((prevState) => ({
      ...prevState,
      series: normalize(totalTerpakai),
      labels: dataLabels,
    }));
    setSisaOptions((prevState) => ({
      ...prevState,
      series: normalize(totalSisa),
      labels: dataLabels,
    }));
  };

  const handleNext = () => setCurrentSlide((prevSlide) => (prevSlide + 1) % 3);
  const handlePrev = () =>
    setCurrentSlide((prevSlide) => (prevSlide - 1 + 3) % 3);

  const slides = [
    { options: totalOptions, title: "Total Anggaran" },
    { options: realisasiOptions, title: "Realisasi Anggaran" },
    { options: sisaOptions, title: "Sisa Anggaran" },
  ];

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={slides[currentSlide].title}>
          <Row>
            <Col>
              <div id="piechart" className="d-flex justify-content-center">
                <Chart
                  options={slides[currentSlide].options}
                  series={slides[currentSlide].options.series}
                  type="pie"
                  width={1100}
                  customScale={0.8}
                />
              </div>
            </Col>
          </Row>
          <div className="row position-absolute top-50 start-0 translate-middle-y">
            <Button
              color="link"
              className="rounded-circle"
              onClick={() => handlePrev()}
            >
              <ChevronLeft />
            </Button>
          </div>
          <div className="row position-absolute top-50 end-0 translate-middle-y">
            <Button
              color="link"
              className="rounded-circle"
              onClick={() => handleNext()}
            >
              <ChevronRight />
            </Button>
          </div>
        </CollapseableCard>
      </Col>
    </Fragment>
  );
};

export default TotalChart;
